// Defoalt is for SECONDARY SCHOOLS API
export const environment = {
  baseUrl: 'https://api.ebill.so:5001/api',
  url: 'https://api.ebill.so:5001/',
  production: true
};